import { throwError, of } from 'rxjs';
import { delay, retryWhen, switchMap, } from 'rxjs/operators';
/**
 * Add a retry after a given delay (in milliseconds)
 * @param obs
 * @param options
 *
 * @returns the new observable stream with retry
 */
export function retryWithDelay(obs, options) {
    const retryCount = options.retryCount || 10;
    const delayMs = options.delay || 0;
    const errorFactory = options.errorFactory ||
        function (options) {
            return new Error(`Maximum retry of ${options.retryCount} exceeded. Last error: ${options.error}`);
        };
    if (retryCount <= 0) {
        return obs;
    }
    return obs.pipe(retryWhen((errors) => {
        return errors.pipe(switchMap((error, index) => {
            if (index >= retryCount) {
                return throwError(errorFactory({
                    retryCount,
                    delay: delayMs,
                    error,
                }));
            }
            else {
                return of(error).pipe(delay(delayMs));
            }
        }));
    }));
}
